import { CRICKET_SCORES } from "../../../config/games";

export class CricketController {
  static calculateScores = (
    value,
    multiple,
    currentRound,
    players,
    scoreMultiplier,
    scoreTotal
  ) => {
    const { player: currentPlayer } = currentRound;
    // si c'est une valeur de cricket
    if (CRICKET_SCORES.includes(value)) {
      let cumulMultiple = currentRound.cricket[value] + multiple;
      let score = value * multiple;
      if (multiple > 1 && cumulMultiple >= 3) {
        score = value * (multiple - (3 - currentRound.cricket[value]));
      }

      // on check si le curentPlayer a tout fermé
      if (cumulMultiple >= 3) {
        // si tout est fermé, on check les autres players
        let notClosedForEveryone = false;
        for (let p = 0; p < players.length; p++) {
          if (players[p].cricket[value] < 3 && !notClosedForEveryone) {
            // si ce n'est pas fermé, on ajoute le score au player en défaut
            // players[p].currentScore = players[p].currentScore + score;
            notClosedForEveryone = true;
          }
        }
        // si tout le monde n'a pas fermé le currentValue, on incrémente le currentScore
        if (notClosedForEveryone) {
          currentRound.currentScore = score;
          currentRound.total = score + currentRound.total;
          players[currentRound.player].currentScore = score;
        }
      }
    }
    return {
      currentRound,
      scoreMultiplier: scoreMultiplier !== multiple ? multiple : 1,
      players,
      scoreTotal,
      currentPlayerWinner: CricketController.isWinner(players, currentPlayer),
      
    };
  };

  static isWinner = (updatedPlayers, currentPlayer) => {
    let isBestScore = false;
    // Recherche du meilleur score
    console.log(updatedPlayers);
    const bestScore = Math.max.apply(Math, updatedPlayers.map((o) => o.currentScore));

    // TODO: ne pas oublier de checker si un autre joueur a tout fermé et a le même nombre de points
    let nbBestScore = 0;
    for (let p = 0; p < updatedPlayers.length; p++) {
      let nbClosed = 0;
      CRICKET_SCORES.forEach((cricketValue) => {
        if (updatedPlayers[p].cricket[cricketValue] >= 3) {
          console.log(cricketValue, updatedPlayers[p].cricket[cricketValue]);
          nbClosed++;
        }
      });

      if (currentPlayer === p) {
        isBestScore =
          nbClosed >= CRICKET_SCORES.length &&
          bestScore >= updatedPlayers[currentPlayer].currentScore;
      }
    }

    return isBestScore;
  };
}
